var map = {
	"./TextData.auris": 1701,
	"./TextData.auris.ts": 1701,
	"./TextData.elenia": 445,
	"./TextData.elenia.ts": 445,
	"./TextData.jes": 7956,
	"./TextData.jes.ts": 7956,
	"./TextData.loimua": 1143,
	"./TextData.loimua.ts": 1143,
	"./TextData.nice": 1091,
	"./TextData.nice.ts": 1091,
	"./TextData.ts": 4247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7161;